function initSinglePromoBannerSlider(sliderContainer) {
  if (!sliderContainer) return;

  if (typeof Swiper === "undefined") {
    if (document.readyState === "complete") {
      setTimeout(() => initSinglePromoBannerSlider(sliderContainer), 200);
    } else {
      window.addEventListener("load", () => initSinglePromoBannerSlider(sliderContainer), { once: true });
    }
    return;
  }


  // Destroy previous Swiper instance if any
  if (sliderContainer.swiper) {
    try {
      sliderContainer.swiper.destroy(true, true);
    } catch (e) {
      console.warn("Swiper destroy error:", e);
    }
  }

  // Remove any previously added manual clones
  sliderContainer.querySelectorAll('.swiper-slide[data-promo-clone="true"]').forEach((el) => el.remove());

  let slides = sliderContainer.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)");
  const originalSlideCount = slides.length;
  if (!originalSlideCount) return;

  const isAutoplay = sliderContainer.dataset.autoplay === "true";
  const autoplaySpeed = parseInt(sliderContainer.dataset.speed) || 4000;

  const parentSection =
    sliderContainer.closest(".sdusa-promo-section") || document;
  const nextEl = parentSection.querySelector(".sdusa-promo-next");
  const prevEl = parentSection.querySelector(".sdusa-promo-prev");

  // Prevent text selection & handle accessible keyboard activation on arrows
  [nextEl, prevEl].forEach((btn) => {
    if (!btn) return;
    if (!btn.dataset.mousedownBound) {
      btn.dataset.mousedownBound = "true";
      btn.addEventListener("mousedown", (e) => e.preventDefault());
    }
    if (btn.dataset.keyboardBound) return;
    btn.dataset.keyboardBound = "true";
    btn.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      if (btn.getAttribute("aria-disabled") !== "true" && !btn.classList.contains("swiper-button-disabled")) {
        btn.click();
      }
    });
  });

  // Prevent Swiper from sliding when clicking banner buttons
  const bannerBtns = parentSection.querySelectorAll(".sdusa-promo-btn");
  bannerBtns.forEach((btn) => {
    if (btn.dataset.stopSwipingReady === "true") return;
    btn.dataset.stopSwipingReady = "true";
    btn.addEventListener("click", (e) => e.stopPropagation());
    btn.addEventListener("pointerdown", (e) => e.stopPropagation());
    btn.addEventListener("touchstart", (e) => e.stopPropagation(), { passive: true });
  });

  // - When autoplay is ON: continuous loop with arrows always active (if > 1 slide)
  // - When autoplay is OFF: arrows disable at beginning and end, no loop
  const shouldLoop = isAutoplay && originalSlideCount > 1;

  // Swiper 6 requires slides >= slidesPerView * 2 to loop seamlessly without warnings/bugs.
  // With desktop slidesPerView: 2, duplicate slides when autoplay is ON and count is 2..4.
  if (shouldLoop && originalSlideCount <= 4) {
    const wrapper = sliderContainer.querySelector(".swiper-wrapper");
    if (wrapper) {
      Array.from(slides).forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute("data-promo-clone", "true");
        wrapper.appendChild(clone);
      });
      slides = sliderContainer.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)");
    }
  }

  // Hide arrows only if there is 1 slide
  const shouldHideArrows = originalSlideCount <= 1;
  [nextEl, prevEl].forEach((btn) => {
    if (!btn) return;
    btn.style.display = shouldHideArrows ? "none" : "";
    btn.setAttribute("aria-hidden", shouldHideArrows ? "true" : "false");
    btn.tabIndex = shouldHideArrows ? -1 : 0;
  });

  function updateArrows(swiper) {
    if (!prevEl || !nextEl) return;
    swiper = swiper?.params ? swiper : sliderContainer.swiper;
    if (!swiper) return;

    if (isAutoplay && originalSlideCount > 1) {
      // Autoplay ON: arrows NEVER disable
      prevEl.classList.remove("swiper-button-disabled");
      nextEl.classList.remove("swiper-button-disabled");
      prevEl.setAttribute("aria-disabled", "false");
      nextEl.setAttribute("aria-disabled", "false");
    } else {
      // Autoplay OFF: disable prev arrow at start, disable next arrow at end
      const isBeg = Boolean(swiper.isBeginning);
      const isEnd = Boolean(swiper.isEnd);
      prevEl.classList.toggle("swiper-button-disabled", isBeg);
      nextEl.classList.toggle("swiper-button-disabled", isEnd);
      prevEl.setAttribute("aria-disabled", isBeg ? "true" : "false");
      nextEl.setAttribute("aria-disabled", isEnd ? "true" : "false");
    }
  }

  const autoplayConfig = shouldLoop
    ? { delay: autoplaySpeed, disableOnInteraction: false }
    : false;

  const swiperInstance = new Swiper(sliderContainer, {
    slidesPerView: 2,
    spaceBetween: 24,
    loop: shouldLoop,
    rewind: false,
    watchOverflow: false,
    observer: true,
    observeParents: true,
    preventClicks: true,
    preventClicksPropagation: true,
    touchStartPreventDefault: false,
    noSwiping: true,
    noSwipingSelector: ".sdusa-promo-btn",
    autoplay: autoplayConfig,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
      disabledClass: "swiper-button-disabled",
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 16 },
      768: { slidesPerView: Math.min(originalSlideCount, 2), spaceBetween: 24 },
    },
    on: {
      init: function() { updateArrows(this); },
      slideChange: function() { updateArrows(this); },
      slideChangeTransitionEnd: function() { updateArrows(this); },
      reachBeginning: function() { updateArrows(this); },
      reachEnd: function() { updateArrows(this); },
      fromEdge: function() { updateArrows(this); },
      resize: function() { updateArrows(this); },
      observerUpdate: function() { updateArrows(this); },
    },
  });

  if (shouldLoop && swiperInstance.autoplay) {
    swiperInstance.autoplay.start();
  }

  setTimeout(() => {
    if (swiperInstance && !swiperInstance.destroyed) {
      swiperInstance.update();
      updateArrows(swiperInstance);
    }
  }, 100);
}

function initPromoBannerSlider() {
  const sliderContainers = document.querySelectorAll(".sdusa-promo-swiper");
  sliderContainers.forEach(initSinglePromoBannerSlider);
}

function setupPromoBannerObserver() {
  const sliderContainers = document.querySelectorAll(".sdusa-promo-swiper");
  if (!sliderContainers.length) return;

  if (!("IntersectionObserver" in window) || (window.Shopify && window.Shopify.designMode)) {
    initPromoBannerSlider();
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        obs.unobserve(entry.target);
        initSinglePromoBannerSlider(entry.target);
      }
    });
  }, { rootMargin: "350px 0px" });

  sliderContainers.forEach((c) => observer.observe(c));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupPromoBannerObserver);
} else {
  setupPromoBannerObserver();
}
document.addEventListener("shopify:section:load", initPromoBannerSlider);
document.addEventListener("shopify:section:select", initPromoBannerSlider);
